import React, { useEffect, useState } from "react";
import "./app.css";

function App() {
  const [data, setData] = useState();
  const [error, setError] = useState(null);
  const myApiKey = "cMaNNHPRW1y1jeNtKec1MuyUIM7UwRTIjfgeMYfc";

  const fetchImageOfTheDay = () => {
    fetch(`https://api.nasa.gov/planetary/apod?api_key=${myApiKey}`)
      .then((response) => {
        if (!response.ok) {
          throw new Error("Failed to fetch APOD");
        }
        return response.json();
      })
      .then((fetchedData) => setData(fetchedData))
      .catch((error) => setError(error.message));
  };

  useEffect(() => {
    fetchImageOfTheDay();
  }, []);

  return (
    <div className="app">
      {" "}
      {data ? (
        <div className="container">
          <div className="gore">
            <h1>
              NASA Picture Of The Da<span>y</span>
            </h1>
            <p className="copyright">
              &copy; {new Date().getFullYear()}{" "}
              <a
                href="https://tristoposto.hr/"
                target="_blank"
                rel="noreferrer"
              >
                Tristoposto
              </a>
            </p>
          </div>
          <div className="dolje">
            <div className="lijevo">
              <div className="content">
                <div className="datum_i_naslov">
                  <h2>{data.date}</h2>
                  <h3>{data.title}</h3>
                </div>
                <div className="desc">
                  <p>{data.explanation}</p>
                </div>
                <div className="btn">
                  <a
                    className="link"
                    href={data.url}
                    target="_blank"
                    rel="noreferrer"
                  >
                    Link of the picture
                  </a>
                  <p className="potpis">
                    {new Date().getFullYear()}{" "}
                    <a
                      href="https://tristoposto.hr/"
                      target="_blank"
                      rel="noreferrer"
                    >
                      Tristoposto &copy;
                    </a>
                  </p>
                </div>
              </div>
            </div>
            <div className="desno">
              <div className="za_sliku">
                <img src={data.url} alt={data.explanation} />
              </div>
            </div>
          </div>
        </div>
      ) : (
        <p className="loading"> Loading... </p>
      )}
    </div>
  );
}

export default App;
